import AttendType from "./AttendType";
import Member from "./Member";

class DatePollInfo {
    date: Date;
    pollData: MemberAndAttendType[];

    constructor(date: Date, pollData: MemberAndAttendType[]) {
        this.date = date;
        this.pollData = pollData;
    };

    getAttendCount(): number {
        return this.pollData.filter((item) => item.attendType === AttendType.ATTEND).length
    };

    getNotSureCount(): number {
        return this.pollData.filter((item) => item.attendType === AttendType.NOT_SURE).length
    }

    getAbsentCount(): number {
        return this.pollData.filter((item) => item.attendType === AttendType.ABSENT).length
    };

    getScore(): number {
        return this.getAttendCount() * 1.5 + this.getNotSureCount() * 1;
    }

    isMemberVoted(member: Member): boolean {
        return this.pollData.find(item => item.member.id === member.id) !== undefined;
    }
}

class MemberAndAttendType {
    member: Member;
    attendType: AttendType;

    constructor(member: Member, attendType: AttendType) {
        this.member = member;
        this.attendType = attendType;
    }
}

export {DatePollInfo, MemberAndAttendType};